<template>
  <div style="min-height:1000px;display:flex;flex-direction: column;justify-content: space-between;">
    <header_index></header_index>
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="topleft">
          <img class="touxiang"
               :src="info.cardPicture"
               alt="" />
          <span class="name"
                :style="nameNum == 0 ? '' : 'font-size:' + nameNum + 'px'">{{ info.name }}</span>
          <span class="zhicheng">{{ info.techTitle }}</span>
          <div class="more">
            <img style="width:20px;height:17px;margin-bottom:-2px"
                 src="../../assets/img/icon/fensi2.png"
                 alt="" />
            <span>{{ info.fans }}</span>
            <img src="../../assets/img/icon/liulan2.png"
                 style="margin-left:30px"
                 alt="" />
            <span>{{ info.pageview }}</span>
          </div>
          <div class="tlbox"
               style="color:#000000"
               v-show="!info.subption"
               @click="toDingyue(1)">
            <span>+订阅</span>
          </div>
          <div class="tlbox"
               style="color:#000000"
               v-show="info.subption"
               @click="toDingyue(2)">
            <span>取消订阅</span>
          </div>
          <div class="tlbox"
               @click="tomingpian"
               style="background: #DF0019;">
            <span>个人名片</span>
          </div>
          <div class="tlbox"
               style="background: #003157;"
               @click="Isliuyan = true">
            <span>发送站内信</span>
          </div>
        </div>
        <div class="topright">
          <div class="topimg"
               @click="toEnter">
            <img src="../../assets/img/icon/zhuanjiaicon.png"
                 alt="" />
            <span>学科专家</span>
          </div>
          <div class="trfanhui"
               @click="fanhui">
            <img src="../../assets/img/icon/fanhui.png"
                 alt="" />
            <span>返回专家列表</span>
          </div>
          <span class="trdanwei">{{ info.unit }}</span>
          <div class="trzhuanchang"
               v-show="info.speciality">
            <span>学术专长：</span>
            <span>{{ info.speciality }}</span>
          </div>
          <div class="trhengxian"></div>
          <div class="trjianjie">{{ info.detailsInfo }}</div>
        </div>
      </div>
    </div>
    <div class="box1"
         v-if="boxIndex == 1">
      <div class="top2 EC_width"
           v-show="dongtaiList.length > 0 || yinpinList.length > 0">
        <div v-if="dongtaiList.length > 0">
          <div class="pagetitle">
            <span>TA的动态</span>
          </div>
          <div class="t2box1">
            <img :src="dongtaiList[0].pictUrl"
                 v-if="dongtaiList[0]"
                 @click="toDongtaiDetail(dongtaiList[0])"
                 alt="" />
            <div class="dongtaiList">
              <div class="dongtaiBox"
                   v-for="(item, index) in dongtaiList"
                   @click="toDongtaiDetail(item)"
                   :key="index">
                <span class="span">{{ item.title }}</span>
                <div v-show="item.type == 3"
                     v-for="(items, indexs) in item.labelName.split(',')"
                     :key="indexs">
                  <span>{{ items }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="yinpinList.length > 0">
          <!-- <div> -->
          <div class="pagetitle">
            <span>TA的音频</span>
          </div>
          <div class="topBox">
            <div class="tbbox">
              <div class="yinpinbox"
                   v-for="(item, index) in yinpinList.slice(tbIndex, tbIndex + 4)"
                   :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
                   :key="index">
                <img :src="item.audioCoverResUrl"
                     class="fengmian"
                     alt="" />
                <img src="../../assets/img/icon/bofang3.png"
                     v-show="zantingid != item.id"
                     class="fengmianicon"
                     @click="bofangyinpin(item.audioResUrl, item.id)"
                     alt="" />
                <img src="/image/icon/icons8.gif"
                     style="border-radius: 50%;box-sizing:border-box"
                     v-show="zantingid == item.id"
                     class="fengmianicon"
                     @click="bofangyinpin(item.audioResUrl, item.id)"
                     alt="" />
                <div class="yinpinright">
                  <span v-if="item.title">{{ item.title }}</span>
                  <!-- <div style="width:100%;height:1px;color:#eee"></div> -->
                  <div class="bofangNum">
                    <img src="../../assets/img/icon/you.png"
                         alt="" />
                    <span>{{ item.changeBrowseNum }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="tbleft tbbtn"
                 v-show="yinpinList.length > 4">
              <img src="../../assets/img/icon/left.png"
                   v-show="tbIndex == 0"
                   alt="" />
              <img src="../../assets/img/icon/bg-left.png"
                   style="cursor: pointer;"
                   @click="tbIndex = tbIndex - 4"
                   v-show="tbIndex != 0"
                   alt="" />
            </div>
            <div class="tbright tbbtn"
                 v-show="yinpinList.length > 4">
              <img src="../../assets/img/icon/right.png"
                   v-show="tbIndex + 4 >= yinpinList.length"
                   alt="" />
              <img src="../../assets/img/icon/bg-right.png"
                   style="cursor: pointer;"
                   v-show="tbIndex + 4 < yinpinList.length"
                   @click="tbIndex = tbIndex + 4"
                   alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="top3f">
        <div class="top3 EC_width"
             v-if="kechengbiaoqianList.length > 0">
          <div class="pagetitle">
            <span>TA的课程</span>
          </div>
          <div class="t3top">
            <div class="t3tbox1">
              <div class="t3tb1left">
                <span class="t3ttitle"
                      :style="neiRongStr == '' ? 'color:#0B8586' : ''"
                      @click="neiRongStr = ''">全部内容</span>
                <img class="you2"
                     src="../../assets/img/icon/you2.png"
                     alt="" />
                <div class="biaoqian"
                     :style="isbqzhankai ? '' : 'white-space: nowrap;'">
                  <span v-for="(item, index) in kechengbiaoqianList"
                        :key="index"
                        :style="getbiaoqianList(item.id) ? 'color: #007380;' : ''"
                        @click="tobiaoqian(item.id)">{{ item.name }}（{{ item.count }}）</span>
                </div>
              </div>
              <div class="t3tb1right"
                   @click="isbqzhankai = !isbqzhankai">
                <span>更多</span>
                <img src="../../assets/img/icon/xia3.png"
                     style="margin-left:10px"
                     alt="" />
              </div>
            </div>
            <div class="t3tbox2">
              <span class="t3ttitle"
                    :style="kechengtype == 0 ? 'color:#0B8586' : ''"
                    @click="kechengtype = 0">全部类型</span>
              <img class="you2"
                   src="../../assets/img/icon/you2.png"
                   alt="" />
              <span :style="kechengtype == 2 ? 'color:#0B8586' : ''"
                    @click="kechengtype = 2">视频</span>
              <span :style="kechengtype == 3 ? 'color:#0B8586' : ''"
                    @click="kechengtype = 3">音频</span>
              <span :style="kechengtype == 4 ? 'color:#0B8586' : ''"
                    @click="kechengtype = 4">电子书</span>
            </div>
          </div>
          <div class="t3mid"
               v-show="kechengList.length > 0">
            <div class="t3mbox"
                 v-for="(item, index) in kechengList"
                 :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
                 @click="tokecheng(item.id)"
                 :key="index">
              <img :src="item.acr_Pict"
                   alt="" />
              <div class="t3mboxbot">
                <span class="t3title"
                      v-if="item.title">{{ item.title }}</span>
                <div class="t3biaoqian">
                  <div v-for="(items, index) in item.labelName.split(',').slice(0,3)"
                       :key="index + 's'"
                       :style="index == 0 ? 'margin-left:0' : ''"
                       v-show="items != ''">
                    <span>{{ items }}</span>
                  </div>
                </div>
                <div class="t3more">
                  <!-- <span v-show="item.price != 0">{{ item.price }}</span>
                  <span style="color:red"
                        v-show="item.price == 0">免费</span> -->
                  <span style="color:red"
                        v-show="item.discountStatus == 2">免费</span>
                  <span style="color:red"
                        v-show="item.discountStatus == 1">VIP专享</span>
                  <span v-show="item.discountStatus == 0">￥{{item.price}}</span>
                  <div>
                    <img src="../../assets/img/icon/ren.png"
                         style="width:10px;height:11px;margin-right:10px"
                         alt="" />
                    <span>{{ item.playSum }}人</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <pagination :total="pageCount"
                      :limit="pageSize"
                      :page="pageIndex"
                      v-show="kechengList.length>0"
                      @page-change="pageChange"></pagination> -->
          <div class="t3bot"
               v-show="dianList.length > 1">
            <div class="dian"
                 v-for="(item, index) in dianList"
                 :key="index"
                 @click="dianing = item"
                 :style="item == dianing ? 'background:#0B8586;border-color:#0B8586' : ''"></div>
          </div>
          <div class="t3mid2"
               v-show="kechengList.length == 0">
            <span>没有找到符合条件的课程</span>
          </div>
        </div>
      </div>
      <div class="top4 EC_width"
           v-if="info.linkShow && linkList.length > 0">
        <div class="pagetitle">
          <span>TA的Link</span>
        </div>
        <div class="topBox">
          <div class="tbbox">
            <div class="linkbox"
                 v-for="(item, index) in linkList"
                 @click="toLink(item.l_Url)"
                 :key="index">
              <img :src="item.pictureUrl"
                   class="fengmian"
                   alt="" />
              <span v-if="item">{{ item.title }}</span>
            </div>
          </div>
          <div class="tbleft tbbtn"
               v-show="linktotalpage > 1">
            <img src="../../assets/img/icon/left.png"
                 v-show="linkpage == 1"
                 alt="" />
            <img src="../../assets/img/icon/bg-left.png"
                 style="cursor: pointer;"
                 @click="linkpage = linkpage - 1"
                 v-show="linkpage > 1"
                 alt="" />
          </div>
          <div class="tbright tbbtn"
               v-show="linktotalpage > 1">
            <img src="../../assets/img/icon/right.png"
                 v-show="linkpage == linktotalpage"
                 alt="" />
            <img src="../../assets/img/icon/bg-right.png"
                 style="cursor: pointer;"
                 v-show="linkpage < linktotalpage"
                 @click="linkpage = linkpage + 1"
                 alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="box2 EC_width"
         v-if="boxIndex == 2">
      <div class="dttop"
           v-if="DongtaiDetail != ''">
        <div class="dttoptop">
          <span class="dttitle">{{ DongtaiDetail.title }}</span>
          <span class="dttitle2"
                @click="boxIndex = 1">返回个人主页>></span>
        </div>

        <div class="dtmore">
          <div class="dtleft">
            <img src="../../assets/img/icon/shizhong.png"
                 alt="" />
            <span>{{ DongtaiDetail.createTime }}</span>
            <img src="../../assets/img/icon/dianji.png"
                 style="margin-left:30px"
                 alt="" />
            <span>{{ DongtaiDetail.hits }}</span>
          </div>
          <div class="dtright"
               v-if="DongtaiDetail.labelName">
            <div v-for="(item, index) in DongtaiDetail.labelName.split(',')"
                 class="dtbioaqian"
                 :key="index"
                 v-show="item && item != 'x'">
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="DongtaiDetail != ''"
           v-html="DongtaiDetail.contentText"></div>
    </div>
    <el-dialog title="留言"
               :visible.sync="Isliuyan"
               class="liuyan"
               width="800px">
      <textarea v-model="liuyan"></textarea>
      <div class="liuyanMid">
        <div class="lymLeft">
          <span>上传图片</span>
          <webupload fileaccept=".jpg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     style="margin:0 10px;"
                     :onSuccess="handleSuccess1">
            <img :src="lyImg1"
                 alt="" />
          </webupload>
          <webupload fileaccept=".jpg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     style="margin:0 10px;"
                     :onSuccess="handleSuccess2">
            <img :src="lyImg2"
                 alt="" />
          </webupload>
          <span style="color: #B6B6B6;">最多上传2张图片</span>
        </div>
        <div>
          <span :style="liuyan.length > 200 ? 'color:red' : ''">{{ liuyan.length }}</span>
          <span>/200</span>
        </div>
      </div>
      <div class="liuyanBot">
        <div style="background: #007380;margin-right:10px;color:#fff;"
             @click="toLiuyan">
          <span>提交</span>
        </div>
        <div @click="Isliuyan = false">
          <span>取消</span>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog :visible.sync="IsMingpian"
               class="mingpian"
               ref="mingpian"
               id="mingpiandom"
               width="302px">
      <img src="../../assets/img/icon/mingpiantop.png"
           class="mptop"
           alt="">
      <img src="../../assets/img/icon/mingpianright.png"
           class="mpright"
           alt="">
      <img src="../../assets/img/icon/guanbi.png"
           @click="IsMingpian=false"
           v-if="IsBcMingpian"
           class="guanbi"
           alt="">
      <div class="mingtop">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <span> 全科医学 · 入驻专家 </span>
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
        <img src="../../assets/img/icon/xing.png"
             class="xing"
             alt="">
      </div>
      <div class="mingtop2">
        全科路上
      </div>
      <div class="mingtop3">
        带你找到医学
      </div>
      <div class="mingtop4">
        前进的方向！
      </div>
      <div class="mingtop5">
        综合医院全科医学科的定位与发展！
      </div>
      <img src="../../assets/img/icon/mingpianmid.png"
           class="mingtop6"
           alt="">
      <div class="mingtop7">
        <span class="name">{{info.name}}</span>
        <span class="zhicheng">{{info.techTitle}}</span>
        <span class="unit">{{info.unit}}</span>
        <div class="erweima"
             id="qrcode"
             ref="qrcodeImg"></div>
        <span class="saoyisao">微信扫一扫</span>
        <span class="wangzhi">www.chinagp.net</span>
      </div>
      <img src="../../assets/img/icon/baocun.png"
           class="baocun"
           @click="baocun"
           v-if="IsBcMingpian"
           alt="">
    </el-dialog> -->
    <el-dialog :visible.sync="IsMingpian"
               class="mingpian"
               ref="mingpian"
               top="200px"
               width="302px">
      <img src="../../assets/img/icon/guanbi.png"
           @click="IsMingpian = false"
           v-if="IsBcMingpian"
           class="guanbi"
           style="right: -30px;top:-20px"
           alt="" />
      <div class="card"
           id="mingpiandom">
        <img :src="info.cardPicture"
             class="touxiang"
             alt="" />
        <span class="name">{{ info.name }}</span>
        <p class="unit">{{ info.unit }}</p>
        <p class="zhicheng">{{ info.techTitle }}</p>
        <div class="erweima"
             id="qrcode"
             ref="qrcodeImg"></div>
      </div>
      <img src="../../assets/img/icon/baocun.png"
           class="baocun"
           @click="baocun"
           v-if="IsBcMingpian"
           alt="" />
    </el-dialog>
    <div style="flex:1"></div>
    <footer_index></footer_index>
  </div>
</template>

<script>
import webupload from '../../components/webupload/webupload.vue';
import QRCode from 'qrcodejs2';
import html2canvas from 'html2canvas';
import header_index from '../../components/header2';
import footer_index from './footer_index.vue';
export default {
  name: 'expertsDetail',
  components: {
    webupload,
    header_index,
    footer_index
  },
  data () {
    return {
      info: '',
      dongtaiList: [],
      boxIndex: 1,
      DongtaiDetail: '',
      tbIndex: 0,
      yinpinList: [],
      isbofang: '',
      bofangurl: '',
      linkList: [],
      linkpage: 1,
      linktotalpage: 1,
      Isliuyan: false,
      liuyan: '',
      lyImg1: '/image/index/update.png',
      lyImg2: '/image/index/update.png',
      orgid: 0,
      liuyanImgId: '',
      liuyanImgUrl: '',
      kechengbiaoqianList: [],
      isbqzhankai: false,
      kechengList: [],
      neiRongStr: '',
      kechengtype: 0,
      IsMingpian: false,
      IsBcMingpian: true,
      qrc: '',
      iszanting: false,
      dianList: [],
      zantingid: 0,
      dianing: 1,
      nameNum: 0
    };
  },
  watch: {
    linkpage: function () {
      this.GetLink(this.linkpage);
    },
    neiRongStr: function () {
      this.getKecheng();
    },
    kechengtype: function () {
      this.getKecheng();
    },
    dianing: function () {
      this.getKecheng();
    }
  },
  created () {
    this.orgid = Number(this.$route.query.id);
    if (this.$route.query.type != undefined) {
      this.httphelper
        .post('/api/EnterpriseApi/GetArticleDynamicInfoByID', {
          id: Number(this.$route.query.type)
        })
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data == null) return;
            this.DongtaiDetail = res.data.data;
            this.boxIndex = 2;
          }
        });
    }
    this.GetExpertsInfo();
    this.GetDongtai();
    this.GetYinpin();
    this.GetLink(1);
    this.getKechengbiaoqian();
    this.getKecheng();
  },
  methods: {
    handleSuccess1 (response) {
      this.lyImg1 = response.ossfileurl;
      if (this.liuyanImgId == '') {
        this.liuyanImgId = response.resid.toString();
        this.liuyanImgUrl = response.ossfileurl;
      } else {
        this.liuyanImgId = this.liuyanImgId + ',' + response.resid;
        this.liuyanImgUrl = this.liuyanImgUrl + ',' + response.ossfileurl;
      }
    },
    handleSuccess2 (response) {
      this.lyImg2 = response.ossfileurl;
      if (this.liuyanImgId == '') {
        this.liuyanImgId = response.resid.toString();
        this.liuyanImgUrl = response.ossfileurl;
      } else {
        this.liuyanImgId = this.liuyanImgId + ',' + response.resid;
        this.liuyanImgUrl = this.liuyanImgUrl + ',' + response.ossfileurl;
      }
    },
    GetExpertsInfo () {
      let id = 0;
      if (localStorage.getItem('ResData')) {
        id = Number(JSON.parse(localStorage.getItem('ResData')).id);
      }
      this.httphelper
        .post('/api/CGPExpertApi/GetExpertInfoContent', {
          ExpertId: Number(this.$route.query.id),
          UserId: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.info = res.data.data;
            let word = /[a-zA-Z]/;
            let num = res.data.data.name.length;
            if (word.test(res.data.data.name)) {
              if (num < 12) {
                this.nameNum = 24;
              } else if (12 < num && num < 16) {
                this.nameNum = 20;
              } else if (16 < num && num < 20) {
                this.nameNum = 16;
              } else {
                this.nameNum = 12;
              }
            }
          }
        });
    },
    fanhui () {
      if (this.isbofang) {
        this.zantingid = 0;
        this.isbofang.pause();
      }
      this.$router.push({
        path: '/experts'
      });
    },
    toEnter () {
      if (this.isbofang) {
        this.zantingid = 0;
        this.isbofang.pause();
      }
      window.open('/user/userExpertsEnter', '_blank');
    },
    GetDongtai () {
      this.httphelper
        .get('/api/CGPExpertApi/GetExpertDynamics', {
          ExpertId: Number(this.$route.query.id),
          RowCount: 10
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data.courseList.length > 0) {
              this.dongtaiList.push(res.data.courseList[0]);
            }
            for (let i = 0; i < res.data.dynamicsList.length; i++) {
              this.dongtaiList.push(res.data.dynamicsList[i]);
            }
            for (let i = 1; i < res.data.courseList.length; i++) {
              this.dongtaiList.push(res.data.courseList[i]);
            }
          }
        });
    },
    getKechengbiaoqian () {
      this.httphelper
        .get('/api/CourseApi/GetLabelCourseList', {
          ExpertId: Number(this.$route.query.id)
        })
        .then(res => {
          if (res.code == 200) {
            this.kechengbiaoqianList = res.data;
          }
        });
    },
    getKecheng () {
      this.httphelper
        .post('/api/CGPInfoApi/GetGpCourseVideoInfoPageLists', {
          labelgather: this.neiRongStr,
          orderBy: 0,
          pageIndex: this.dianing,
          pageSize: 8,
          fuzzysearch: '',
          expertId: this.$route.query.id,
          resinfoType: this.kechengtype
        })
        .then(res => {
          if (res.data.code == 200) {
            this.kechengList = res.data.data.gpCourseVideoInfoViews;
            if (this.dianList.length != 0) {
              this.dianList = [];
            }
            for (let i = 1; i <= Math.ceil(res.data.data.pageCount / 8); i++) {
              this.dianList.push(i);
            }
          }
        });
    },
    toDongtaiDetail (item) {
      if (this.isbofang) {
        this.zantingid = 0;
        this.isbofang.pause();
      }
      if (item.type == 1) {
        this.tokecheng(item.id);
      } else if (item.type == 3) {
        this.httphelper
          .post('/api/EnterpriseApi/GetArticleDynamicInfoByID', {
            id: item.id
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data == null) return;
              this.DongtaiDetail = res.data.data;
              this.boxIndex = 2;
            }
          });
      }
    },
    GetYinpin () {
      this.httphelper
        .get('/api/CGPExpertApi/GetAudioBroadcast', {
          ExpertId: Number(this.$route.query.id),
          type: 1
        })
        .then(res => {
          if (res.code == 200) {
            this.yinpinList = res.data;
          }
        });
    },
    bofangyinpin (url, id) {
      if (this.zantingid == id) this.zantingid = 0;
      else this.zantingid = id;
      if (this.isbofang == '') {
        this.isbofang = new Audio(url);
        this.isbofang.play();
        this.bofangurl = url;
        this.toyinpin(id);
      } else {
        if (this.bofangurl == url) {
          this.isbofang.pause();
          this.isbofang = '';
          this.bofangurl = '';
        } else {
          this.isbofang.pause();
          this.isbofang = new Audio(url);
          this.isbofang.play();
          this.bofangurl = url;
          this.toyinpin(id);
        }
      }
    },
    GetLink (page) {
      this.httphelper
        .get('/api/CGPExpertApi/GetExpertLinkList', {
          Id: Number(this.$route.query.id),
          type: 1,
          IsShow: true,
          limit: 6,
          Page: page
        })
        .then(res => {
          if (res.code == 200) {
            this.linkList = res.data;
            this.linktotalpage = res.totalpage;
          }
        });
    },
    toyinpin (id) {
      this.httphelper
        .post('/api/CGPExpertApi/UpdAudioBrowseNum', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetYinpin();
          }
        });
    },
    toDingyue (type) {
      if (type == 1 && !localStorage.getItem('ResData')) return this.$message.warning('请登录');
      this.httphelper
        .post('/api/CGPExpertApi/ExpertFollow', {
          ExpertId: Number(this.$route.query.id),
          UserId: Number(JSON.parse(localStorage.getItem('ResData')).id),
          Status: type
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetExpertsInfo();
            this.$message.success(type == 1 ? '订阅成功' : '取消订阅成功');
          } else {
            this.$message.success('订阅失败');
          }
        });
    },
    toLiuyan () {
      if (this.liuyan == '') return this.$message.warning('请输入留言内容');
      this.httphelper
        .post('/api/CGPExpertApi/SaveExpertMsgInfo', {
          mPId: '',
          mReceliveUserID: Number(this.$route.query.id),
          mSendUserID: Number(JSON.parse(localStorage.getItem('ResData')).id),
          mReadFlag: 0,
          mMessage: this.liuyan,
          mImageResID: this.liuyanImgId,
          mImageResUrl: this.liuyanImgUrl
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('留言成功');
          } else {
            this.$message.warning('留言失败');
          }
          this.Isliuyan = false;
        });
    },
    getbiaoqianList (id) {
      for (let i = 0; i < this.neiRongStr.split(',').length; i++) {
        if (this.neiRongStr.split(',')[i] == id) return true;
      }
    },
    tobiaoqian (id) {
      let a = true;
      let neiRongStr = this.neiRongStr.split(',');
      for (let i = 0; i < neiRongStr.length; i++) {
        if (neiRongStr[i] == id) {
          neiRongStr.splice(i, 1);
          a = false;
        }
      }
      if (a == true) neiRongStr.push(id);
      this.neiRongStr = neiRongStr.join(',');
    },
    tomingpian () {
      this.IsMingpian = true;
      this.$nextTick(() => {
        if (this.qrc == '') {
          this.qrc = new QRCode(this.$refs.qrcodeImg, {
            // width: 80,
            // height: 80,
            text: window.location.href, // 二维码地址
            colorDark: '#000',
            colorLight: '#fff'
          });
        } else return;
      });
    },
    async baocun () {
      this.IsBcMingpian = false;
      const el = document.getElementById('mingpiandom');
      this.$message({
        message: '保存中，请耐心等待或自行截图',
        type: 'success'
      });
      await html2canvas(el, {
        width: 302,
        height: 670,
        windowWidth: 302,
        windowHeight: 670,
        // y: 20,
        allowTaint: true,
        useCORS: true,
        scale: 2,
        dpi: 30000
      }).then(canvas => {
        var url = canvas.toDataURL('image/png');
        var a = document.createElement('a');
        var event = new MouseEvent('click');
        a.download = '专家名片';
        a.href = url;
        a.dispatchEvent(event);
      });
      this.IsBcMingpian = true;
    },
    tokecheng (id) {
      if (this.isbofang) {
        this.zantingid = 0;
        this.isbofang.pause();
      }
      window.open(this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id, '_blank');
    },
    toLink (url) {
      window.open(url, "_blank")
    }
  }
};
</script>

<style scoped>
.bannerWrap {
    height: 526px;
    width: 100%;
    min-width: 1240px;
    background: url('/image/index/zhuanjiabanner.png');
    background-size: 100% 526px;
    background-repeat: no-repeat;
}

.topbanner {
    height: 526px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.topbanner .topright {
    background-image: url('/image/index/zhuanjiabg.png');
    width: 1006px;
    height: 412px;
    margin-right: -30px;
    margin-bottom: -60px;
    position: relative;
    padding: 34px 88px 90px 64px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.topbanner .topimg {
    background-image: url('/image/index/zhuanjiatopbg.png');
    width: 117px;
    height: 117px;
    position: absolute;
    top: -50px;
    right: 77px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
    box-sizing: border-box;
    padding: 13px 5px 30px 0;
    cursor: pointer;
}
.topbanner .topleft {
    width: 188px;
    height: 410px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    font-family: Microsoft YaHei;
    color: #ffffff;
}
.topleft .touxiang {
    width: 188px;
    height: 188px;
    border-radius: 50%;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}
.topleft .name {
    font-weight: bold;
    font-size: 26px;
}
.topleft .more img {
    margin-right: 10px;
}
.topleft .tlbox {
    width: 160px;
    height: 30px;
    background: #ffffff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
}
.trfanhui {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
}
.trfanhui img {
    margin-right: 10px;
}
.trdanwei {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
}
.trzhuanchang {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.trhengxian {
    width: 100%;
    height: 1px;
    background-color: #eee;
}
.trjianjie {
    width: 100%;
    height: 135px;
    padding-right: 30px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    text-indent: 2em;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.trjianjie::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.trjianjie::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.trjianjie::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #eee;
    border-radius: 6px;
}
.top2,
.top3,
.top4 {
    padding: 60px 0 40px;
}
.pagetitle {
    padding-bottom: 14px;
    margin-bottom: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 30px;
    border-bottom: 1px solid #eee;
}
.pagetitle span {
    padding-left: 14px;
    border-left: 3px solid #107c81;
    line-height: 30px;
    height: 30px;
    display: inline-block;
}
.top3f {
    background: #f6f7fb;
}
.t2box1 {
    display: flex;
    padding-bottom: 70px;
}
.t2box1 img {
    width: 280px;
    height: 158px;
    border-radius: 6px;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}
.t2box1 .dongtaiList {
    flex: 1;
    height: 158px;
    overflow-y: scroll;
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 55px;
    text-indent: 2em;
    scrollbar-color: transparent transparent;
}
.t2box1 .dongtaiList::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.t2box1 .dongtaiList::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.t2box1 .dongtaiList::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #eee;
    border-radius: 6px;
}
.t2box1 .dongtaiList .span:hover {
    color: #0b8586;
}
.t2box1 .dongtaiList .span {
    cursor: pointer;
}
.dongtaiBox {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
}
.dongtaiBox div {
    height: 20px;
    margin-left: 10px;
    border: 1px solid #0b8586;
    border-radius: 10px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    line-height: 20px;
    padding: 0 6px;
}
.dongtaiBox div span {
    text-align: center;
    margin-left: -32px;
}
.box2 {
    padding-bottom: 40px;
}
.box2 .dttop {
    padding-bottom: 14px;
    margin-bottom: 30px;

    border-bottom: 1px solid #eee;
}
.dttoptop {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.dttoptop .dttitle2 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #010101;
    cursor: pointer;
}
.box2 .dttop .dttitle {
    padding-left: 14px;
    border-left: 3px solid #107c81;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 26px;
    height: 26px;
    display: inline-block;
    margin-top: 30px;
    margin-bottom: 30px;
}
.box2 .dttop img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
}
.box2 .dttop .dtmore {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.box2 .dtleft {
    display: flex;
    align-items: center;
}
.box2 .dtright {
    display: flex;
}
.box2 .dtbioaqian {
    padding: 3px 10px;
    border: 1px solid #0b8586;
    font-size: 12px;
    line-height: 12px;
    color: #0b8586;
    margin-left: 10px;
}
.top2 .topBox {
    position: relative;
    padding-bottom: 30px;
    height: 125px;
}
.top2 .tbbox {
    display: flex;
}
.top2 .tbbox .fengmian {
    width: 76px;
    height: 49px;
    border-radius: 10px;
}
.top2 .tbbox .fengmianicon {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 30px;
    left: 40px;
    cursor: pointer;
}
.top2 .tbbox .yinpinright {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 23px;
    flex: 1;
}
.top2 .tbbox .bofangNum {
    display: flex;
    align-items: center;
    border-top: 1px dashed rgb(231, 231, 231);
    width: 100%;
    padding-top: 10px;
}
.top2 .tbbox .bofangNum img {
    margin-right: 10px;
}
.top2 .tbbtn {
    position: absolute;
    bottom: 73px;
}
.top2 .tbleft {
    left: -50px;
}
.top2 .tbright {
    right: -50px;
}
.top2 .tbbtn img {
    width: 32px;
    height: 32px;
}
.top2 .yinpinbox {
    width: 301px;
    height: 125px;
    background: #f6f7fb;
    border-radius: 5px;
    margin-right: 12px;
    box-sizing: border-box;
    padding: 18px 15px;
    display: flex;
    position: relative;
}
.top4 .topBox {
    position: relative;
    padding-bottom: 30px;
    height: 125px;
}
.top4 .tbbox {
    display: flex;
}
.top4 .linkbox {
    width: 206px;
    height: 115px;
    box-sizing: border-box;
    padding: 5px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.top4 .linkbox img {
    width: 70px;
    height: 70px;
    border-radius: 10px;
}
.top4 .tbbtn {
    position: absolute;
    bottom: 70px;
}
.top4 .tbleft {
    left: -57px;
}
.top4 .tbright {
    right: -57px;
}
.top4 .tbbtn img {
    width: 37px;
    height: 37px;
}
.liuyan ::v-deep .el-dialog__title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-left: 20px;
    position: relative;
    top: 20px;
}
.liuyan ::v-deep .el-dialog__body {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 40px;
}
.liuyan textarea {
    width: 720px;
    height: 179px;
    background: #ffffff;
    border: 1px solid #c1c1c1;
    box-sizing: border-box;
    resize: none;
    outline: none;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #767676;
    padding: 20px;
}
.liuyanMid {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 18px;
}
.lymLeft {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.lymLeft img {
    width: 52px;
    height: 52px;
}
.lymRight {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
}
.liuyanBot {
    display: flex;
    justify-content: center;
}
.liuyanBot div {
    width: 140px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #b6b6b6;
    border-radius: 18px;
    box-sizing: border-box;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.t3top {
    /* height: 60px; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 30px;
}
.t3tbox1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
}
.t3tb1right {
    width: 70px;
    height: 25px;
    border: 1px solid #e5e5e5;
    /* margin-top: -5px; */
    box-sizing: border-box;
    margin-left: 30px;
    line-height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.t3tb1right span {
    margin-left: 0 !important;
}
.t3tb1left {
    flex: 1;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
}
.t3tb1left .biaoqian {
    width: 1066px;
}
.t3top .you2 {
    margin-left: 10px;
    width: 6px;
    height: 11px;
    margin-top: 5px;
}
.t3top span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin-left: 20px;
    /* text-overflow: ellipsis; */
    white-space: nowrap;
    cursor: pointer;
}
.t3ttitle {
    margin-left: 0 !important;
}
.t3mid {
    display: flex;
    flex-wrap: wrap;
}
.t3mbox {
    height: 288px;
    width: 280px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-right: 40px;
    margin-bottom: 30px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 5px 5px;
    cursor: pointer;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}
.t3mbox img {
    height: 158px;
    width: 280px;
}
.t3mboxbot {
    padding: 15px 15px 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
}
.t3title {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
}
.t3more {
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #919ca3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.t3biaoqian {
    display: flex;
    flex-wrap: wrap;
}
.t3biaoqian div {
    background: #ffffff;
    border: 1px solid #979fa6;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #979fa6;
    padding: 0px 3px;
    /* margin-left: 3px; */
    margin-right: 3px;
    margin-top: 1px;
    margin-bottom: 1px;
}
.t3biaoqian span {
    white-space: nowrap;
}
.t3bot {
    display: flex;
    align-items: center;
    justify-content: center;
}
.t3bot .dian {
    width: 14px;
    height: 14px;
    border: 2px solid #cfcfcf;
    border-radius: 50%;
    margin: 10px 5px 0;
    cursor: pointer;
    box-sizing: border-box;
}
.t3mid2 {
    width: 100%;
    text-align: center;
    line-height: 100px;
}
.mingpian ::v-deep .el-dialog__header {
    display: none;
}
.mingpian ::v-deep .el-dialog__body {
    height: 670px;
    padding: 0 !important;
    position: relative;
}
.mingpian {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
}
.mingpian .guanbi {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
.mingpian .baocun {
    position: absolute;
    bottom: 14px;
    right: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
.mingpian .mptop {
    position: absolute;
    top: 0px;
    right: 0px;
}
.mingpian .mpright {
    position: absolute;
    bottom: 0px;
    right: 0px;
    height: 650px;
    width: 200px;
}
.mingtop {
    position: absolute;
    top: 40px;
    left: 35px;
    font-size: 12px;
    color: #ffffff;
}

.mingtop .xing {
    width: 8px;
    height: 7px;
}
.mingtop2 {
    position: absolute;
    top: 120px;
    left: 35px;
    font-size: 30px;
    color: #ffffff;
    font-family: Source Han Sans CN;
    font-weight: bold;
    padding-bottom: 10px;
    width: 75%;
    border-bottom: 1px solid #ffffff;
}
.mingtop3 {
    position: absolute;
    top: 174px;
    left: 35px;
    font-size: 38px;
    color: #ffffff;
    font-family: Source Han Sans CN;
    font-weight: bold;
}
.mingtop4 {
    position: absolute;
    top: 220px;
    left: 35px;
    font-size: 28px;
    color: #ffffff;
    font-family: Source Han Sans CN;
}
.mingtop5 {
    position: absolute;
    top: 280px;
    left: 35px;
    font-size: 13px;
    color: #ffffff;
    font-family: Source Han Sans CN;
}
.mingtop6 {
    position: absolute;
    top: 320px;
    left: 35px;
    width: 55px;
    height: 8px;
}
.mingtop7 {
    position: absolute;
    top: 370px;
    left: 0px;
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.mingtop7 .name {
    font-size: 26px;
    color: #000000;
    font-family: Source Han Sans CN;
    font-weight: bold;
    margin-top: 20px;
}
.mingtop7 .zhicheng {
    font-size: 14px;
    color: #000000;
    font-family: Source Han Sans CN;
}
.mingtop7 .unit {
    font-size: 14px;
    color: #000000;
    font-family: Source Han Sans CN;
}
.mingtop7 .wangzhi {
    font-size: 13px;
    color: #000000;
    font-family: Source Han Sans CN;
    margin-top: 20px;
    margin-bottom: 40px;
}
.mingtop7 .saoyisao {
    font-size: 12px;
    color: #000000;
    font-family: Source Han Sans CN;
}
.mingtop7 .erweima {
    width: 80px;
    height: 80px;
}
.card {
    width: 100%;
    height: 100%;
    background-image: url('../../assets/img/organ/card5.jpg');
    /* background-size: 100%; */
    position: relative;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}
.card .touxiang {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: absolute;
    top: 278px;
    left: 101px;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}
.card .name {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 397px;
    color: #fff;
    font-size: 18px;
    font-weight: 800;
}
.card .unit {
    font-size: 13px;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 450px;
    color: #fff;
}
.card .zhicheng {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 426px;
    color: #fff;
    font-size: 16px;
}
.card .erweima {
    width: 53px;
    height: 52px;
    position: absolute;
    top: 488px;
    left: 125px;
    overflow: hidden;
    border: 1px solid #fff;
    box-sizing: border-box;
}
</style>
